var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobileScreen)?_c('div',{staticClass:"signin"},[_c('div',{staticClass:"signin__letfside bg-primary-opacity"},[_c('onboarding')],1),_c('div',{staticClass:"signin__rightside"},[_c('sign-in-form'),_c('helpdesk')],1)]):_c('div',{staticClass:"signin"},[_c('div',{staticClass:"signin__mobile--wrapper"},[_c('sign-in-form'),_c('helpdesk')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }